<script lang="ts" setup>
import { ref, computed } from "vue";
import ImageProduct from "@/components/ui/ImageProduct.vue";
import BaseLink from "~/components/buttons/BaseLink.vue";
import { vElementHover } from "@vueuse/components";

const props = defineProps({
  product: {
    type: Object,
    default: null,
  },
});

const isHovered = ref(false);

const firstImage = computed(() => {
  if (props.product?.images?.length > 0) {
    return props.product.images[0].image;
  }
  return "/images/imagen-no-disponible.png";
});

const onHover = (state: boolean) => {
  isHovered.value = state;
};
</script>

<template>
  <base-link
    v-element-hover="onHover"
    :to="product.links.self ? product.links.self : '/'"
    class="link-underline link-underline-opacity-0 p-1 px-lg-2 h-100 d-flex flex-column justify-content-end align-content-center link-new-product mw-100"
    :class="{ 'shadow-inset': isHovered }"
  >
    <div
      class="w-100 d-flex flex-row justify-content-center align-items-center"
    >
      <image-product
        :image="firstImage"
        :min-height="112"
        :max-height="150"
        :max-sm-height="150"
      />
    </div>

    <h5
      class="w-100 w-lg-100 text-center mx-auto text-secondary text-l2-truncate mt-1 px-2 small"
    >
      {{ product.name }}
    </h5>
    <div
      v-if="product.brands"
      class="product-brand d-inline-block text-center pe-2 mb-2"
    >
      <span class="fw-bold small-sm text-truncate">
        {{ product.brands.name }}
      </span>
    </div>
  </base-link>
</template>

<style lang="sass" scoped>
.shadow-inset
  box-shadow: inset 0px 1px 5px var(--bs-gray-200)

.link-new-product:active
  background-color: var(--bs-gray-100)

.product-brand
  text-transform: uppercase
</style>
